import useLocalStorage from '../utils/useLocalStorage';

function usePaperSettings() {
  const [outputPaperSize, setOutputPaperSize] = useLocalStorage('outputPaperSize', 'LETTER');
  const [customPaperWidth, setCustomPaperWidth] = useLocalStorage('customPaperWidth', 8.5);
  const [customPaperHeight, setCustomPaperHeight] = useLocalStorage('customPaperHeight', 11);
  const [useMillimeters, setUseMillimeters] = useLocalStorage('useMillimeters', false);

  return {
    outputPaperSize, setOutputPaperSize,
    customPaperWidth, setCustomPaperWidth,
    customPaperHeight, setCustomPaperHeight,
    useMillimeters, setUseMillimeters,
  };
}

export default usePaperSettings;
